<template>
    <v-app>
        <v-container>
            <ProActivityLogSetup
                v-model:dialog="dialog"
                :data="data"
                @update:dialog="dialog = $event"
                @update-success="reloadLeadData"
            />
            <div>
                <!-- Lead Header -->
                <div v-if="Object.keys(leadView).length > 0" class="mb-6">
                    <v-card-title class="text-blue-darken-3 font-weight-bold text-body-1 bg-grey-lighten-3">
                        <v-icon left>mdi-account-multiple</v-icon> Proposal Detail - {{ leadView.code }}
                    </v-card-title>

                    <v-card class="px-4 py-2">

                        <v-row dense>
                            <v-col cols="12">
                                <v-card-title class=" font-weight-bold">
                                    <v-icon left>mdi-domain</v-icon> Company Information
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <p class="text-body-2">
                                                <strong>Company:</strong> {{ leadView.company_name }}
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Email:</strong> {{ leadView.company_email }}
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Phone:</strong> {{ leadView.company_phone }}
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Ref no.:</strong> {{ leadView.ref_no }}
                                            </p>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <p class="text-body-2">
                                                <strong>Country:</strong> {{ leadView.company_country?.name }}
                                            </p>
                                            
                                            <p class="text-body-2">
                                                <strong>Company nature of Business:</strong> {{ leadView.company_nature_of_business }}
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Company Website:</strong> {{ leadView.company_website }}
                                            </p>
                                        </v-col>
    
                                        <v-col cols="12" md="4">
                                            <p class="text-body-2">
                                                <strong>Letter Subject:</strong> {{ leadView.letter_sub }}
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Letter Body:</strong> 
                                                <span v-html="leadView.letter_body"></span>
                                            </p>
                                            <p class="text-body-2">
                                                <strong>Letter Description:</strong> 
                                                <span v-html="leadView.letter_description"></span>
                                            </p>
                                            
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-card-title class="text-h6 font-weight-bold">
                                    <v-icon left>mdi-account-tie</v-icon> Contact
                                    Information
                                </v-card-title>
                                <v-card-text>   
                                    <p>
                                        <strong>Name:</strong> {{ leadView.contact_name }}
                                    </p>
                                    <p>
                                        <strong>Designation:</strong>
                                        {{ leadView.contact_designation }}
                                    </p>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>

                <div v-else-if="isLoading" class="text-center my-6">
                    <v-progress-circular
                        indeterminate
                        color="deep-purple"
                    ></v-progress-circular>
                </div>

                <div v-else class="text-center text-grey my-6">
                    <p>No lead data found</p>
                </div>

                <div class="d-flex justify-end mb-6 mx-4" v-if="tab !== 2" >
                    <v-btn
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                        @click="openModal(leadView)"
                    >
                        {{ addButtonText }}
                    </v-btn>
                </div>

                <!-- Tabs -->
                <v-card class="elevation-2">
                    <v-tabs v-model="tab"  align-tabs="center" color="primary">
                        <v-tab size="small" :value="2">Product</v-tab>
                        <v-tab size="small" :value="1">Activity Log</v-tab>
                    </v-tabs>

                    <v-divider></v-divider>

                    <v-tabs-window v-model="tab">

                        <!-- Activity Log Tab -->
                        <v-tabs-window-item :value="1">
                            <v-container fluid>
                                <v-card class="pa-4 elevation-1">
                                    <v-card-title class="text-h6 font-weight-bold text-primary">
                                        <v-icon left>mdi-history</v-icon> Activity Log
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-timeline
                                        v-for="(activity, index) in leadActivity"
                                        :key="index"
                                        align="center"
                                        density="compact"
                                        >
                                            <v-timeline-item size="small" color="deep-purple">
                                                <v-card class="pa-3 w-100" flat>
                                                <div class="d-flex align-center">
                                                    <v-avatar
                                                    icon="$vuetify"
                                                    :image="
                                                        getFileServerUrl +
                                                        (activity.created_by.image_thumb != null
                                                        ? activity.created_by.image_thumb
                                                        : 'uploads/demo_images/user.png')
                                                    "
                                                    size="40"
                                                    ></v-avatar>
                                                    <v-col>
                                                        <h3>{{ activity.created_by.full_name }}</h3>
                                                        <p>
                                                            {{ activity.follow_up_date }}
                                                        </p>
                                                    </v-col>
                                                </div>
                                                <p class="synopsis-text">
                                                    <strong>Description:</strong>
                                                    {{ activity.description }}
                                                </p>
                                                <v-row class="pa-3 align-center">
                                                    <p><strong>Status:</strong></p>
                                                    <v-col class="d-flex ga-1">
                                                    <v-chip
                                                        class="bg-yellow-lighten-1 text-yellow-darken-4 font-weight-bold"
                                                        >{{ activity.proposal_status.name }}</v-chip
                                                    >
                                                    </v-col>
                                                </v-row>
                                                <v-divider></v-divider>
                                                <p class="mt-2">
                                                    <strong>Date:</strong>
                                                    {{ activity.date }}
                                                </p>
                                                </v-card>
                                            </v-timeline-item>
                                        </v-timeline>
                                    </v-card-text>
                                </v-card>
                            </v-container>
                        </v-tabs-window-item>

                        <v-tabs-window-item :value="2">
                            <v-container fluid>
                                <v-card class="pa-4 elevation-1">
                                    <v-data-table
                                    :headers="headers"
                                    :items="products"
                                    :loading="loading"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    hide-default-footer
                                    >
                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>
                                        
                                    </v-data-table>
                                </v-card>
                            </v-container>
                        </v-tabs-window-item>

                    </v-tabs-window>
                </v-card>
            </div>
        </v-container>
    </v-app>
</template>

<script>
import ProActivityLogSetup from "@/components/module/sales/proposal/proActivityLogSetup.vue";
export default {
    components: {
        ProActivityLogSetup
    },
    name: "LeadView",
    data() {
        return {
            id: "",
            tab: 2,
            addButtonText: "Add Daily Update",
            dialog: false,
            assignDialog: false,
            loading: false,
            data: {},
            products: [],
            leadActivity: [],
            isLoading: false,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Product Name", key: "product.name", align: "left", sortable: false },
                { title: "Quantity", key: "qty", align: "left", sortable: false },
                { title: "Rate", key: "rate", align: "left", sortable: false },
                { title: "Total", key: "total", align: "left", sortable: false },
                { title: "Unit", align: "center", key: "product.unit.name", sortable: true },
            ],
        };
    },
    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },
    methods: {
        openModal(data) {
            this.data = { ...data };
            if (this.tab === 1) {
                this.dialog = true; 
            } 
        },
        reloadLeadData() {
            if (this.id) {
                this.isLoading = true;
                this.$store.dispatch("getSalesProposalbyId", this.id).then((response) => {
                    this.leadView = response;
                    this.products = this.leadView.details || [];
                    this.isLoading = false;
                    if (this.tab === 1) {
                        this.leadActivity = this.leadView.log_details || [];
                    }
                });
            }
        },
    },
    watch: {
        tab(val) {
            if (val === 1) {
                this.addButtonText = "Add Daily Update";
                this.leadActivity = this.leadView.log_details || [];
            }
            if (val === 2) {
                this.products = this.leadView.details || [];
            }
        },
    },
    created() {
        this.leadView = {};
        this.leadActivity = [];
    },
    mounted() {
        this.products = this.leadView.details || [];
        const id = this.$route.params.id || "";
        console.log(id);
        if (id) {
            this.id = id;
            this.isLoading = true;
            this.$store.dispatch("getSalesProposalbyId", id).then((response) => {
                console.log(response);
                this.leadView = response;
                this.products = this.leadView.details || [];
                this.isLoading = false;
                this.$store.commit('UNSET_LOADING')
            });
        } else {    
            this.leadView = this.$store.getters.getViewingProposal;
            this.leadActivity = this.leadView?.lead_details || [];
        }
    },
};
</script>

<style scoped>
.w-100 {
    width: 100% !important;
}

.position-relative {
    position: relative;
}

.checkbox-position {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
}

.synopsis-text {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: anywhere;
}
</style>
